import React, { Component } from 'react';
import Slider from 'react-slick';
import './ProductMainAndAltImages.scss';

export class AsNavFor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
    };
    this.moveToSelectedSwatchOnImgSwipe = this.moveToSelectedSwatchOnImgSwipe.bind(this);
  }
  componentDidMount() {
    this.setState({ nav1: this.slider1, nav2: this.slider2 });
  }
  moveToSelectedSwatchOnImgSwipe(index) {
    this.props.passedFunctions.updateAttributeFromAltSwipe(index);
  }
  render() {
    var altImagesToUse = JSON.parse(JSON.stringify(this.props.contentData.altImages || []));
    if (typeof window != 'undefined' && window.injectedAltImageFunction) {
      altImagesToUse = window.injectedAltImageFunction(
        altImagesToUse,
        this.props.passedFunctions.parentState.selectedMainImg
      );
    }

    const settings = {
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      // slidesToShow: 7.5,
      swipeToSlide: true,
      swipe: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            // slidesToShow: 6.5,
          },
        },
      ],
      afterChange: (index) => {
        this.moveToSelectedSwatchOnImgSwipe(index);
      },
    };

    const mainImgSettings = {
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      slidesToShow: 1,
      swipeToSlide: true,
      swipe: true,
      arrows: false,
    };
    if (this.props.selectedMainImg && this.slider1 && altImagesToUse) {
      for (var i = 0; i < altImagesToUse.length; i++) {
        if (altImagesToUse[i].imageName === this.props.selectedMainImg) {
          this.slider1.slickGoTo(i);
        }
      }
    }

    return (
      <div>
        {altImagesToUse == undefined ? (
          <img
            src={`//dimg.dillards.com/is/image/DillardsZoom/main/${this.props.contentData.fullImage.imageNameForUrl}/${this.props.selectedMainImg}.jpg`}
          />
        ) : (
          <React.Fragment>
            <Slider asNavFor={this.state.nav2} ref={(slider) => (this.slider1 = slider)} {...mainImgSettings}>
              {(altImagesToUse || []).map((altImage, index) => (
                <div key={altImage.imageName + '__' + index}>
                  <img
                    className='zoomedImg'
                    src={`//dimg.dillards.com/is/image/DillardsZoom/main/${this.props.contentData.fullImage.imageNameForUrl}/${altImage.overideImageName || altImage.imageName}.jpg`}
                    data-imagename={altImage.imageName}
                    alt={altImage.altText}
                  />
                </div>
              ))}
            </Slider>

            <div className='altZoomContainer'>
              <Slider asNavFor={this.state.nav1} ref={(slider) => (this.slider2 = slider)} {...settings}>
                {(altImagesToUse || []).map((altImage, index) => (
                  <div key={altImage.imageName + '__' + index}>
                    <img
                      src={`//dimg.dillards.com/is/image/DillardsZoom/alt/${this.props.contentData.fullImage.imageNameForUrl}/${altImage.overideImageName || altImage.imageName}.jpg`}
                      alt={altImage.altText}
                      data-imagename={altImage.imageName}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}
